import { useEffect, useCallback } from "react";

const useCloseOnBlur = (
  focusOn,
  fieldName,
  focusedField,
  opened,
  setOpened
) => {
  const onFocus = useCallback(() => focusOn(fieldName), [focusOn, fieldName]);

  useEffect(() => {
    if (!setOpened) {
      return;
    }
    if (focusedField !== fieldName && opened) {
      setOpened(false);
    }
  }, [focusedField, opened, fieldName, setOpened]);

  return onFocus;
};

export default useCloseOnBlur;
